import React, { useEffect, useState } from "react";
import { cloneDeep } from "lodash";
import { Button } from "antd";
import { alertify, handleApiExceptions, prepFilters } from "../../app_methods";
import { Text1 } from "../../styles";
import { CreateSplitAccountModal } from "../Settings/InstaCollect/splitAccountModal";
import { SplitAccountModel } from "../../models/split_account";
import { SplitAccDrawer } from "./styles";
// import { SplitsConfigForm } from "../Common/Forms";
import { ConfigureSplitAccountModal } from "../Settings/InstaCollect/SplitAccountConfigurationModal";
import { getSplitAccountColumns, getSplitAccountFilters } from "./constants";
import { EaseTable } from "../../libs/EaseTable";

const initialPagination = {
  pageSize: 10,
  total: 0,
  current: 1,
  showSizeChanger: true,
  pageSizeOptions: ["10", "25", "50"],
  showTotal: (total) => {
    return `Total ${total} items`;
  },
};

const initialFilter = {
  account_number: undefined,
  account_holder_name: undefined,
};

const SplitAccountsDrawer = (props) => {
  const { width, visible, onClose, merchantId, split_settlement_type, virtualAccount, cva_id, can_edit } = props;
  const [isRetrieving, setIsRetrieving] = useState(false);
  const [splitAccounts, setSplitAccountData] = useState([]);
  const [selectedSplitAccount, setSelectedSplitAccount] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfigureSplitAccountModal, setShowConfigureSplitAccountModal] = useState(false);

  const [pagination, setPagination] = useState(initialPagination);
  const [filters, setFilters] = useState({
    account_number: undefined,
    account_holder_name: undefined,
  });

  useEffect(() => {
    if (visible && merchantId) {
      setPagination(initialPagination);
      setFilters(initialFilter);
      fetchSplitAccounts(initialPagination, initialFilter);
    }
  }, [visible]);

  const fetchSplitAccounts = async (_pagination = pagination, _filters = filters) => {
    setIsRetrieving(true);
    const response = await SplitAccountModel.list({
      merchant_id: merchantId,
      custom_virtual_account_id: split_settlement_type === "CVA" ? cva_id : null,
      ...{ pageSize: _pagination?.pageSize, current: _pagination?.current },
      ...prepFilters(_filters),
    });
    if (!response.success) {
      handleApiExceptions(response);
      setIsRetrieving(false);
      return;
    }
    setIsRetrieving(false);
    const resData = response?.data;
    setPagination({ ..._pagination, total: resData?.count });
    setSplitAccountData(resData?.results || []);
  };

  const saveAccount = async (values) => {
    setIsRetrieving(true);
    const account = new SplitAccountModel(values);
    const response = await account.save();
    if (!response.success) {
      setIsRetrieving(false);
      handleApiExceptions(response);
      return;
    }
    setShowModal(false);
    alertify("Success", `Split Account ${values.id ? "updated" : "created"} successfully.`, "success", {
      cancelText: "Close",
    });
    setIsRetrieving(false);
    fetchSplitAccounts();
  };

  const handleSplitUpdate = (splitAccount) => {
    setSelectedSplitAccount(splitAccount);
    setShowModal(!showModal);
  };

  const handleTableChange = (tableInfo) => {
    const _pagination = cloneDeep(tableInfo?.pagination);
    if (tableInfo.trigger === "filters") _pagination.current = 1;

    const _filters = tableInfo.filters;
    setFilters(_filters);
    setPagination(_pagination);
    fetchSplitAccounts(_pagination, _filters);
  };

  const toggleConfigureModal = () => {
    setShowConfigureSplitAccountModal(false);
    fetchSplitAccounts();
  };

  return (
    <SplitAccDrawer
      className="split-accounts-drawer"
      visible={visible}
      title={<Text1>Split Accounts</Text1>}
      onClose={onClose}
      width={width}
      hideBackArrow={true}
      hideFooter={true}
      destroyOnClose
    >
      <div className="h-100">
        <div className="w-100">
          {/* <SplitsConfigForm
            fetchSplitAccounts={fetchSplitAccounts}
            onClose={onClose}
            setSelectedSplitAccount={setSelectedSplitAccount}
            isRetrieving={isRetrieving}
            setShowModal={setShowModal}
            setShowConfigureSplitAccountModal={setShowConfigureSplitAccountModal}
            handleSplitUpdate={handleSplitUpdate}
            splitAccounts={splitAccounts}
            split_settlement_type={split_settlement_type}
            virtualAccount={virtualAccount}
            can_edit={can_edit}
            handleTableChange={handleTableChange}
            pagination={pagination}
            filters={filters}
          /> */}
          <>
            <div className="form-header d-flex justify-content-end mt-3">
              <Button
                className="ml-auto"
                type="secondary"
                icon="plus-circle"
                loading={isRetrieving}
                onClick={() => {
                  setShowModal(true);
                  setSelectedSplitAccount(null);
                }}
              >
                Create Split Account
              </Button>
              {can_edit ? (
                <Button
                  className="ml-1"
                  type="dashed"
                  icon="setting"
                  loading={isRetrieving}
                  onClick={() => {
                    setShowConfigureSplitAccountModal(true);
                    setSelectedSplitAccount(null);
                  }}
                >
                  Configure Split Account
                </Button>
              ) : null}
            </div>
            <EaseTable
              loading={isRetrieving}
              className="w-100 mt-1"
              rowKey="id"
              data={splitAccounts}
              columns={getSplitAccountColumns({
                handleSplitUpdate,
                // isInitialSplitType,
                // splitType,
                // form,
                // selectedPriorities,
                // setSelectedPriorities,
                // splitAccounts,
                // approvedList,
                // split_settlement_type,
                // can_edit,
              })}
              handleTableChange={handleTableChange}
              pagination={pagination}
              totalRecords={pagination?.total ?? 0}
              filterNodes={getSplitAccountFilters()}
            />
          </>
        </div>
      </div>
      <CreateSplitAccountModal
        visible={showModal}
        onCancel={() => setShowModal(false)}
        merchantID={merchantId}
        selectedSplitAccount={selectedSplitAccount}
        saveAccount={saveAccount}
        loading={isRetrieving}
      />
      <ConfigureSplitAccountModal
        visible={showConfigureSplitAccountModal}
        onCancel={() => setShowConfigureSplitAccountModal(false)}
        merchantId={merchantId}
        selectedSplitAccount={selectedSplitAccount}
        saveAccount={saveAccount}
        loading={isRetrieving}
        splitAccounts={splitAccounts}
        split_settlement_type={split_settlement_type}
        cva_id={cva_id}
        virtualAccount={virtualAccount}
        toggleConfigureModal={toggleConfigureModal}
      />
    </SplitAccDrawer>
  );
};

export { SplitAccountsDrawer };
